<template>
  <div class="share-buttons">
    <ul>
      <li><h3>Share:</h3></li>
      <!-- Facebook -->
      <li class="facebook-link">
        <a class="hide-decoration" :href="url" target="_blank"
          @click="shareFacebook($event)">
          <span class="icon icon-facebook"></span>
        </a>
      </li>

      <!-- Twitter -->
      <li class="twitter-link">
        <a class="hide-decoration" :href="url" target="_blank"
          @click="shareTwitter($event)">
          <span class="icon icon-twitter"></span>
        </a>
      </li>

      <!-- Linked In -->
      <!-- <li class="linkedin-link">
        <a class="hide-decoration" :href="url" target="_blank"
          @click="shareLinkedIn($event)">
          <span class="icon icon-linkedin"></span>
        </a>
      </li> -->

      <!-- Email -->
      <!-- <li class="email-link" v-if="emailEnabled">
        <a class="hide-decoration" :href="emailHref" target="_blank">
          <v-icon class="icon email-icon">mdi-email</v-icon>
        </a>
      </li> -->
    </ul>
  </div>
</template>

<script>
const props = {
  url: {
    type: String,
    default: window.location.href
  },
  twitterMessage: {
    type: String,
    required: false
  },
  emailSubject: {
    type: String,
    required: false
  },
  emailMessage: {
    type: String,
    required: false
  },
  emailEnabled: {
    type: Boolean,
    default: true
  }
}

const computed = {
  emailHref () {
    const subject = encodeURIComponent(this.emailSubject || this.defaultEmailSubject)
    const message = encodeURIComponent(this.emailMessage || this.defaultEmailMessage)
    return `mailto:${this.url}?subject=${subject}&body=${message} - ${this.url}`
  }
}

const methods = {
  shareFacebook (e) {
    e.preventDefault()
    window.FB.ui({
      method: 'share',
      href: this.url
    }, (response) => {})
  },
  shareTwitter (e) {
    e.preventDefault()
    const y = (window.outerHeight / 2) - 200
    const x = (window.outerWidth / 2) - 300
    const url = encodeURIComponent(this.url)
    const text = encodeURIComponent(this.twitterMessage || this.defaultTwitterMessage)
    const twitterUrl = `https://twitter.com/intent/tweet?&original_referer=${url}&text=${text}&tw_p=tweetbutton&url=${url}`
    window.open(
      twitterUrl,
      'Twitter',
      `width=600,height=400,left=${x},top=${y}`
    )
  },
  shareLinkedIn (e) {
    e.preventDefault()
    const url = `https://www.linkedin.com/shareArticle?mini=true&url=${this.url}`
    const y = parseInt(window.outerHeight / 2) - 200
    window.open(url, 'Linked In', `width=600,height=400,left=0,top=${y}`)
  }
}

export default {
  props,
  computed,
  methods,
  data () {
    return {
      defaultTwitterMessage: 'The latest @0ptimusPredicts 2020 Election Forecasting Update:',
      defaultEmailSubject: 'Øptimus Predicts Forecasting Update',
      defaultEmailMessage: 'Check out the latest election forecasting update from Øptimus and Decision Desk HQ'
    }
  }
}
</script>

<style>
#footer .share-buttons {
  margin-bottom: 20px;
}

.share-buttons h3 {
  margin-right: 0.5rem;
  color: #a2a2a2;
  font-weight: 400;
}

.share-buttons ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: center;
}

.share-buttons li {
  list-style-type: none;
  margin: 0 0.5rem;
}

.share-buttons li a .icon {
  color: #a2a2a2;
}

.share-buttons li a:hover .icon {
  color: initial;
}
</style>
